<template>
	<main id="archive-posts" class="archive page main" :key="'archive-'+currentPostType">

		<div class="headg-filters margin-bottom-xl">
			
			<SingleHeading @changeSearch="v => filters.search = v" @changeCategory="v => filters.venu_category = v" @changePostCategory="v => filters.category = v"  @changePlace="v => filters.venu_place = v" />
			
			<ModuleBuilder />

		</div>

		<PostsGrid :posts="postsToShow.slice(0, toShowCount)" class="container" />

		<div v-if="isMoreToShow && postsToShow.length"  class="margin-bottom-xl margin-top-xl load-more-button text-center">
			<Button aria-label="Load more" hasIcon iconType="down" uppercase v-observe-visibility="visibilityChanged" type="darkLight" @click.native="loadMore()">Last flere</Button>
		</div>

		<div v-if="postsLoaded && !isMoreToShow && postsToShow.length == 0"  class="container margin-bottom-lg text-center">
			<div class=" no-resultats">
				<div class="inner-error" v-if="currentPostType !== 'venu'">{{_('Fant ingen arrangementer')}}</div>
				<div class="inner-error" v-if="currentPostType === 'venu'">{{_('Fant ingen opplevelser')}}</div>
			</div>
		</div>

	</main>
</template>


<script>
import PostsGrid from '@/components/parts/PostsGrid'
import Button from '@/components/elements/Button'
import SingleHeading from '@/components/parts/SingleHeading'
import ModuleBuilder from '@/components/ModuleBuilder'

import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'archive-page',
	components:{
		PostsGrid,
		Button,
		SingleHeading,
		ModuleBuilder
	},
	data(){
        return{
			selectedCategory: '',
			postsLoaded: false,
			filters: {
				venu_category : [],
				venu_place: [],
				category : [],
				search: ''
			},
			posts: [],
			toShowDefault: 6,
			toShowCount: 6,
			showBy: 6,
			countAll: 0,
		}
	},
	watch:{
		// postsLoaded(val){
		// 	if(val){
		// 		const urlFilters = Object.assign({}, this.$route.query);
		// 		let query = {}
		// 		if(Object.keys(urlFilters).length ){
		// 			if(urlFilters.hasOwnProperty('venu_category')){
		// 				query = {...query, ... urlFilters }
		// 			}
		// 			if(urlFilters.hasOwnProperty('category')){
		// 				query = {...query, ... urlFilters }
		// 			}
		// 			//consoleconsole.log(query)
		// 		}
		// 		//trigger first router/filters action
		// 	}
		// },

	},
	mounted(){
		this.loadPosts();
		//console.log(this.$route)
	},
	methods:{
		...mapActions([
			'getPost',
		]),
		loadPosts(){
			const VM = this;
			VM.getPost(VM.apiOptLoad).then(res => {
				const { posts } = res.data;
				if(posts && posts.length){
					VM.countAll = posts.length;
					VM.posts = posts;
					VM.postsLoaded = true;
				}
			})
		},
		loadMore(){
			this.toShowCount = this.toShowCount + this.showBy
		},
		visibilityChanged(isVisible){
			if(isVisible){
				this.loadMore();
			}
		},
	},
	computed: {
		...mapGetters([
			'currentPostType',
			'currentPage',
		]),
		apiOptLoad(){
			let orderBy = 'data'
			if(this.currentPostType === 'events') orderBy = 'event_date'
			if(this.currentPostType === 'venu') orderBy = 'title'

			return {
				type: this.currentPostType || 'post',
				order_by : orderBy,
				order : this.currentPostType === 'post' ? 'DESC' : 'ASC',
				limit: 50000,
			}

		},
		
		isMoreToShow(){
			return this.toShowCount < this.postsToShow.length
		},
		postsToShow(){
			const VM = this;
			if(!this.posts) return false
			
			const toShow = VM.posts.filter((p,i)=>{
                //search
                const searchQuery = VM.filters.search 
                let showMe = true
                if(searchQuery) showMe = (p.title.toUpperCase().indexOf(searchQuery.toUpperCase()) > -1)
                return showMe
            }).filter( (p,i) => {
                let showMe = true

				if(VM.filters.venu_category && VM.filters.venu_category.length){
	                showMe = false
					const postCategory = (p.acf && p.acf.category) ? p.acf.category : false;
					showMe = ( postCategory && postCategory.slug && VM.filters.venu_category.includes(postCategory.slug))
				}
				if(VM.filters.category && VM.filters.category.length){
	                showMe = false
					const postCategory = (p.acf && p.acf.category) ? p.acf.category.map( c => c.slug) : false;
					showMe = ( postCategory && postCategory.length && VM.filters.category.some(item => postCategory.includes(item)) )
				}
				return showMe
			}).filter( (p,i) => {
                let showMe = true

				if(VM.filters.venu_place && VM.filters.venu_place.length){
	                showMe = false
					const postZip = (p.acf && p.acf.zip) ? p.acf.zip : false;
					showMe = postZip ?  ~VM.filters.venu_place.indexOf(postZip) : false
				}
				return showMe
			})


			return (toShow && toShow.length) ?  toShow : []
		}
	},

}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.load-more-button .fill-button-text{
	font-size: 18px;
}
.archive{
	.page-heading{
		.page-title, .excerpt{
			text-align: left;
		}
	}
	.no-resultats{
        font-weight: 900;
        margin-top: 30px;
        padding: 30px;
        color: $dark;
        border: 5px solid $dark;
        @include fluid-type($smallResText, $wideResText, 18px, 25px);
    }
}
</style>